import { Component, OnInit, TemplateRef} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global";
import swal from "sweetalert2";
import { Subject } from "rxjs";

@Component({
  selector: "app-save-search",
  templateUrl: "./save-search.component.html",
  styleUrls: ["./save-search.component.css"]
})
export class SaveSearchComponent implements OnInit {
  searchList:any=[]
  search: any=[];
  searchObserver = new Subject<string>();
  constructor(private api: AdminService, public route: ActivatedRoute,private router: Router) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.search = params['search']; 
  });
    this.getSaveSearch()
  }
  getSaveSearch(){ 
    this.api.getDatas(apiUrl._getSaveSearch)
    .subscribe(async (res) => {
      this.searchList = res.data.data; 
    })
  }
  // delete
  delete(id){
    let text = "<p>Are you sure you want to delete this Search?</p>";
      swal.fire({
        html: text,
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonColor: "#EF7E2B",
        cancelButtonColor: "#ffffff",
        confirmButtonText:"Yes",
        cancelButtonText: "No",
        reverseButtons: true,
        width: 500
      }).then((result) => {
        if (result.value) { 
          const data = {
            "id": id, 
          }
          this.api.deleteData(apiUrl._deleteSaveSearch, data).subscribe(res => {
          this.getSaveSearch();
          })
        }
      });
  }
 
  // goToSearch
  goToSearch(title){
    this.search=title
    let queryparams = {}
    queryparams["search"] = this.search; 
    this.router.navigate(['search'], { queryParams: {search: this.search} })
  }
}
